import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img
              src="/img/about-hamilton-pressure-washing-clinton-nc.jpg"
              alt="Hamilton Pressure Washing crew in Clinton, NC"
              className="about-image"
              width="1000"
              height="1000"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h1>About Hamilton Pressure Washing</h1>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              {props.data && props.data.paragraphs
                ? props.data.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))
                : null}
              <h3>Why Choose Us?</h3>
              <div className="list-style row">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
